import { useRouter } from "next/router";
import { filteredQueries } from "~/components/blocks/product/common/blocks/product-related-items/utils/filtered-queries";
import { getVideoRatingForDetail } from "~/components/blocks/product/util/get-video-rating-for-detail";
import type { Href } from "~/const/hrefs";
import { PATHS } from "~/const/paths";
import { useQueryString } from "~/hooks/use-query-string";
import type { G_VideoRatingCategory } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";

/**
 * /detailと/player/で共通するカルーセルアイテムの遷移先を生成する関数を返すカスタムフック
 */
export const useBuildVodDetailHref = () => {
  const { isLoggedIn } = useAuth();
  const { pathname, asPath } = useRouter();
  const queries = useQueryString();

  const buildVodDetailHref = ({ category, id }: { category: G_VideoRatingCategory; id: string }) => {
    const isPlayback = asPath.startsWith(PATHS.VOD_PLAYER);
    const { isGravure, isRegularRestricted } = getVideoRatingForDetail(category);
    const topPathname = isGravure ? PATHS.VOD_GRAVURE : PATHS.VOD;
    const detailPathname = isGravure || isRegularRestricted ? PATHS.VOD_GRAVURE : PATHS.VOD_DETAIL;
    const pathnameFromPlayback = isLoggedIn ? topPathname : detailPathname;

    const href = {
      pathname: isPlayback ? pathnameFromPlayback : pathname,
      query: { ...filteredQueries(queries), season: id },
    } as Href;

    return { href };
  };

  return { buildVodDetailHref };
};
